export default class ToprError {
  constructor(public Code: string, public Message?: string) {
    this.Code = Code
    this.Message = Message
  }
}
